(function Index($, Adzuki)
{
	"use strict";
	var $modal = $(".modal");

	$(document).ready(function documentReady()
	{

		Adzuki.onload('Marketing/index', function onload() {
			var modal_title = $(".modal-title"),
				modal_body  = $(".modal-body");

			loadSalesChart();
			loadSegmentsPie();
			loadSourcesPie();
			loadTouchPointChart();
			Adzuki.Chart.initiateEmailActivityChart();

			$(".comparison-link").on('click', function loadArcComparison(e)
			{
				var href              = $(this),
					comparison_type   = href.data('type'),
					comparison_id     = href.data('comparison-id'),
					comparison_url    = '',
					comparison_title  = href.data('title'),
					comparison_iframe = '',
					$modal            = $(".modal");

				switch (comparison_type) {
					case 'arc':
						comparison_url = '/Clients/_getArcComparison/' + comparison_id;
						break;
					case 'cruise':
						comparison_url = '/Clients/_getCruiseComparison/' + comparison_id;
						break;
					case 'tour':
						comparison_url = '/Clients/_getTourComparison/' + comparison_id;
						break;
					case 'hotel':
						comparison_url = '/Clients/_getHotelComparison/' + comparison_id;
						break;
					default:
						comparison_url = '';
						break;
				}

				$modal.addClass('wide');
				comparison_iframe  = "<iframe src='" + Adzuki.erez_url + Adzuki.base_uri + comparison_url +"' height='500' width='100%' frameborder='0'></iframe>";
				e.preventDefault();

				modal_title.html(comparison_title);
				modal_body.html(comparison_iframe);
			});

			$('.sent-email').click(function showEmail(e)
			{
				var $self          = $(this),
				    $modal         = $(".modal"),
				    modal_title    = $self.data("modal-title"),
				    iframe_src     = $self.data("iframe-src"),
				    iframe_height  = $self.data("iframe-height") || 500,
				    iframe_width   = $self.data("iframe-width") || '100%';

				e.preventDefault();

				$modal.addClass('wide');

				$modal.find('iframe').attr({
					src   : iframe_src,
					height: iframe_height,
					width : iframe_width
				});

				$modal.find('.modal-title').text(modal_title);
				$modal.on('hidden.bs.modal', function _restoreModal() {
					$modal.removeClass('wide').off('hidden.bs.modal');
				}).modal('show');
			});

			$('.view-ecard-model').click(function onViewEcardModelClick(e)
			{
				var $target      = $(e.currentTarget),
					$modal_title = $('.modal-title'),
					$modal_body  = $('.modal-body'),
					model_id     = $target.data('model-id');

				e.preventDefault();

				Adzuki.Ajax.get('/Ecards/view/' + model_id + '/').then(function success(response)
				{
					$('#modalWindow').modal();

					$modal_title.html('View eCard');
					$modal_body.html(response);
				});
			});

			$('.touchpoint-chart-button').click(function toggleTouchPointChart() {
				$('.touchpoint-table').addClass('hidden');
				$('.touchpoint-graph').removeClass('hidden');
				$('.touchpoint-chart-button').addClass('btn-primary');
				$('.touchpoint-table-button').removeClass('btn-primary');
			});

			$('.touchpoint-table-button').click(function toggleTouchPointChart() {
				$('.touchpoint-graph').addClass('hidden');
				$('.touchpoint-table').removeClass('hidden');
				$('.touchpoint-chart-button').removeClass('btn-primary');
				$('.touchpoint-table-button').addClass('btn-primary');
			});

			$('.marketing-effort-summary').on('click', showMarketeingEffortSummary);
		});
	});

	function loadSalesChart() {
		var chart = new Adzuki.Chart('#sales-table', {
			width: '100%',
			title: '',
			vAxis: {
				title: 'Dollars'
			},
			hAxis: {
				title: 'Month of the Year'
			},
			colors: ['#3366CC', '#109618', '#FF9900']
		});

		$(chart).on('ready', function chartReady()
		{
			Adzuki.Ajax.get('/Marketing/salesChart/')
			.then(function getChartData(response)
			{
				chart.setData(response);
				chart.draw('column');
			});
		});
	}

	function loadSegmentsPie() {
		var chart = new Adzuki.Chart('#segment-pie', {
			title  : null,
			width  : '100%',
			pieHole: 0.4,
			vAxis  : {
				title: 'Segment'
			},
			chartArea: {
				width : '100%',
				height: '80%'
			},
			legend: {
				position: 'bottom'
			},
			hAxis: {
				title: 'Sales'
			}
		});

		$(chart).on('ready', function getChartData() {
			Adzuki.Ajax.get('/Marketing/checkSegment/')
			.then(function getChartData(response) {
				if (response.length === 0) {
					$('#chart-options').removeClass('text-center');
					$('#chart-options').html('<div class="alert alert-info">We do not have enough data yet to create your charts.</div>');
				} else {
					Adzuki.Ajax.get('/Marketing/segmentChartPie/')
					.then(function getChartData(jsonResponse) {
						$.each(jsonResponse, function loop(key, value) {
							var new_val = value;
							jsonResponse[key] = new_val;
						});

						chart.setData(jsonResponse);
						chart.draw('pie');
					});
				}
			});
		});
	}

	function loadSourcesPie() {
		var chart = new Adzuki.Chart('#source-pie', {
			title  : null,
			width  : '100%',
			pieHole: 0.4,
			vAxis  : {
				title: 'source'
			},
			chartArea: {
				width : '100%',
				height: '80%'
			},
			legend: {
				position: 'bottom'
			},
			hAxis: {
				title: 'Sales'
			}
		});

		$(chart).on('ready', function getChartData() {
			Adzuki.Ajax.get('/Marketing/checkSource/')
			.then(function getChartData(response) {
				if (response.length === 0) {
					$('#sourcepie-options').removeClass('text-center');
					$('#sourcepie-options').html('<div class="alert alert-info">We do not have enough data yet to create your charts.</div>');
				} else {
					Adzuki.Ajax.get('/Marketing/sourceChartPie/')
					.then(function getChartData(jsonResponse) {
						$.each(jsonResponse, function loop(key, value) {
							var new_val = value;
							jsonResponse[key] = new_val;
						});

						chart.setData(jsonResponse);
						chart.draw('pie');
					});
				}
			});
		});
	}

	function loadTouchPointChart() {
		var barStyle = 'fill-color: #3366CC;';
		var chart = new Adzuki.Chart('#touchpoint-chart', {

			title    : null,
			legend   : 'none',
			width    : '100%',
			chartArea: {height: '100%'},
			vAxis    : {
				title: 'Touchpoint'
			},
			hAxis: {
				title: 'Amount'
			}
		});

		$(chart).on('ready', function getChartData() {
			Adzuki.Ajax.get('/Marketing/checkTouchpointChart/')
			.then(function getChartData(response) {
				if (response === 0) {
				console.log("empty");
				// 	$('#sourcepie-options').removeClass('text-center');
				$('#touchpoint').html('<div class="alert alert-info">We do not have enough data yet to create your graph.</div>');
				} else {
					Adzuki.Ajax.get('/Marketing/touchpointChart/')
					.then(function getChartData(jsonResponse) {
						$.each( jsonResponse, function loop( key, value ) {
							var new_val = value;
							if (key === 0) {
								new_val.push({role: 'style'});
							// add style for each bar in chart
							} else {
								new_val.push(barStyle);
							}
							jsonResponse[key] = new_val;
						});
						chart.setData(jsonResponse);
						chart.draw('bar');
					});
				}
			});
		});

		return;
	}

	function showMarketeingEffortSummary(e) {
		var marketing_effort_id    = $(this).data("id");
		var marketing_effort_title = $(this).data("title");

		e.preventDefault();

		$modal.find('.modal-title').text("Marketing Effort Details - " + marketing_effort_title);
		$modal.find('.modal-body').html('<i class="fa fa-spinner fa-spin fa-2x"></i>&nbsp;Loading...');
		$modal.modal('show');

		Adzuki.Ajax.get('/MarketingEfforts/summary/' + marketing_effort_id)
		.then(function success(data) {
			$modal.find('.modal-body').html(data);
		});
	}
}(jQuery, window.Adzuki || {}));
